import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    description: 'settings.displayoptions.header',
    defaultMessage: 'Display Options',
    id: 'blL0/+',
  },
  headerContent: {
    description: 'settings.displayoptions.headerContent',
    defaultMessage:
      'Make changes to the look and feel of ShipStation. Options with an unlocked icon ({icon}) indicate that Configuration or Administration permissions are required.',
    id: '9vPBnV',
  },
  userSetting: {
    description: 'settings.displayoptions.userSetting',
    defaultMessage: 'indicates a user specific setting',
    id: 'bnOywm',
  },
  accountWideSetting: {
    description: 'settings.displayoptions.accountWideSetting',
    defaultMessage: 'indicates an account wide setting',
    id: 'Z7/VhE',
  },
  generalPreferences: {
    description: 'settings.displayoptions.generalPreferences',
    defaultMessage: 'General Preferences',
    id: 'rUs5Cu',
  },
  orders: {
    description: 'tab header for orders in display settings',
    defaultMessage: 'Orders',
    id: 'KvrRYV',
  },
  products: {
    description: 'settings.displayoptions.products',
    defaultMessage: 'Products',
    id: 'o2OBDJ',
  },
  timeAndUnits: {
    description: 'settings.displayoptions.timeAndUnits',
    defaultMessage: 'Time And Units',
    id: '/0nsqu',
  },
  timeAndDate: {
    description: 'settings.displayoptions.timeAndDate',
    defaultMessage: 'Time & Date',
    id: '3kKS6e',
  },
  unitsOfMeasure: {
    description: 'settings.displayoptions.unitsOfMeasure',
    defaultMessage: 'Units of Measure',
    id: 'KjPlgH',
  },
  uomWarning: {
    description: 'settings.displayoptions.uomWarning',
    defaultMessage:
      'Changing the Units of Measure settings will cause existing weights and dimensions to be converted. Weights and dimensions may be impacted by rounding.',
    id: 'LUQ3Ig',
  },
  timeZone: {
    description: 'settings.displayoptions.timeZone',
    defaultMessage: 'Time Zone',
    id: '5lu+cB',
  },
});

export default messages;
